export enum PosterEditorDesignSubPanels {
  NONE = 'none',
  BACKGROUND_COLOR = 'background-color',
  BACKGROUND_IMAGE = 'background-image',
  BACKGROUND_IMAGE_TINT_COLOR = 'background-image-tint-color',
  BACKGROUND_IMAGE_MULTIPLY_COLOR = 'background-image-multiply-color',
  AI_SUBTITLES = 'ai-subtitles',
  INTRO_ANIMATION_STYLES = 'intro-animation-styles',
  OUTRO_ANIMATION_STYLES = 'outro-animation-styles',
  COLOR_PALETTE_STYLES = 'color-palette-styles',
}

export const AI_WRITER_VIA_DEFAULT_POSTER_CONTEXTUAL_OPTIONS = 'AI_WRITER_VIA_DEFAULT_POSTER_CONTEXTUAL_OPTIONS';
